import { Col, Container, Row } from "components/layout";
import styled from "@emotion/styled";
import mixins from "theme/mixins";

export const Wrapper = styled.div`
  background-color: ${(props) => props.theme.primary};
`;

export const StyledContainer = styled(Container)`
  ${mixins.fontCoda()};

  color: ${(props) => props.theme.white};
  font-size: 12px;
  padding-top: 1rem;
  padding-bottom: 1rem;

  ${mixins.media.tablet`padding-left: 1rem;
    padding-right: 1rem;`};
`;

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.5rem;
`;

export const DropdownElement = styled.div`
  border-radius: 5px;

  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  padding-bottom: 3px;

  background-color: rgba(0, 0, 0, 0.2);
  ${mixins.media.tablet` width: 100%;`};
`;

export const StyledRow = styled(Row)`
  gap: 2rem;
  ${mixins.media.tablet` gap: 1rem;`};
`;

export const StyledCol = styled(Col)`
  flex-basis: auto;
  flex-grow: 0;
`;
